import React from 'react';
import NewsDetails from '../../components/news/NewsDetails';

function News() {
    return (
        <>
            <NewsDetails />
        </>
    )
}

export default News
